import React from 'react';
import { Interpolate } from 'react-i18next';
import Wix from '../../services/wix-sdk-polyfill';

export const POST_DELETE = 'post-delete';
export const POST_PIN = 'post-pin';
export const POST_UNPIN = 'post-unpin';
export const POST_SUBSCRIBED = 'post-subscribe';
export const POST_UNSUBSCRIBED = 'post-unsubscribe';
export const POST_ENABLE_COMMENTING = 'post-enable-commenting';
export const POST_DISABLE_COMMENTING = 'post-disable-commenting';
export const POST_UPDATE = 'post-update';
export const POST_MOVE = 'post-move';
export const POST_CHANGE_CATEGORY = 'post-category-change';
export const POST_ADD_TOP_COMMENT = 'post-add-top-comment';
export const POST_REMOVE_TOP_COMMENT = 'post-remove-top-comment';

export const COMMENT_UPDATE = 'comment-update';
export const COMMENT_DELETE = 'comment-delete';

export const REQUIRE_POST_FIELDS = 'require-post-fields';

export const REQUIRE_CATEGORY_FIELDS = 'require-category-fields';

export const MEMBER_PROMOTE_MODERATOR = 'member-promote-moderator';
export const MEMBER_DEMOTE_MODERATOR = 'member-demote-moderator';

export const MEMBER_BLOCK = 'member-block';
export const MEMBER_UNBLOCK = 'member-unblock';

export const CATEGORY_DELETE = 'category-delete';
export const CATEGORY_UPDATE = 'category-update';
export const CATEGORY_SUBSCRIBED = 'category-subscribed';
export const CATEGORY_UNSUBSCRIBED = 'category-unsubscribed';

export const REQUIRE_PROFILE_FIELDS = 'require-profile-fields';
export const PROFILE_UPDATE = 'profile-update';
export const PROFILE_UPDATE_FAILED = 'profile-update-failed';

export const USER_SUBSCRIBED = 'user-subscribe';
export const USER_UNSUBSCRIBED = 'user-unsubscribe';

export const DEMO_MODE_SITE = 'demo-mode-site';
export const DEMO_MODE_EDITOR = 'demo-mode-editor';
export const DEMO_MODE_PREVIEW = 'demo-mode-preview';

export default {
  [POST_DELETE]: {
    content: () => (
      <Interpolate
        i18nKey="messages.post-deleted"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [POST_UPDATE]: {
    content: () => (
      <Interpolate
        i18nKey="messages.post-updated"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [POST_ENABLE_COMMENTING]: {
    content: () => (
      <Interpolate
        i18nKey="messages.commenting-enabled"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [POST_DISABLE_COMMENTING]: {
    content: () => (
      <Interpolate
        i18nKey="messages.commenting-disabled"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [POST_PIN]: {
    content: () => (
      <Interpolate
        i18nKey="messages.post-pinned"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [POST_UNPIN]: {
    content: () => (
      <Interpolate
        i18nKey="messages.post-unpinned"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [POST_ADD_TOP_COMMENT]: {
    content: () => (
      <Interpolate
        i18nKey="messages.post-top-comment-added"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [POST_REMOVE_TOP_COMMENT]: {
    content: () => (
      <Interpolate
        i18nKey="messages.post-top-comment-removed"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [USER_SUBSCRIBED]: {
    content: () => (
      <Interpolate
        i18nKey="messages.user-subscribed"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [USER_UNSUBSCRIBED]: {
    content: () => (
      <Interpolate
        i18nKey="messages.user-unsubscribed"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [POST_SUBSCRIBED]: {
    content: () => (
      <Interpolate
        i18nKey="messages.post-subscribed"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [POST_UNSUBSCRIBED]: {
    content: () => (
      <Interpolate
        i18nKey="messages.post-unsubscribed"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [POST_MOVE]: {
    content: () => (
      <Interpolate
        i18nKey="messages.post-moved"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [POST_CHANGE_CATEGORY]: {
    content: () => (
      <Interpolate
        i18nKey="messages.post-category-changed"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },

  [COMMENT_UPDATE]: {
    content: () => (
      <Interpolate
        i18nKey="messages.comment-updated"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [COMMENT_DELETE]: {
    content: () => (
      <Interpolate
        i18nKey="messages.comment-deleted"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },

  [REQUIRE_POST_FIELDS]: {
    content: data => {
      const key = data && data.sort().join('-');
      switch (key) {
        case 'title':
          return (
            <Interpolate
              i18nKey="messages.post-title-required"
              useDangerouslySetInnerHTML={true}
            />
          );
        case 'content':
          return (
            <Interpolate
              i18nKey="messages.post-content-required"
              useDangerouslySetInnerHTML={true}
            />
          );
        default:
          return (
            <Interpolate
              i18nKey="messages.post-fields-required"
              useDangerouslySetInnerHTML={true}
            />
          );
      }
    },
    type: 'error',
  },

  [REQUIRE_CATEGORY_FIELDS]: {
    content: data => {
      const key = data && data.sort().join('-');
      switch (key) {
        case 'label':
          return (
            <Interpolate
              i18nKey="messages.category-title-required"
              useDangerouslySetInnerHTML={true}
            />
          );
        default:
          return (
            <Interpolate
              i18nKey="messages.category-fields-required"
              useDangerouslySetInnerHTML={true}
            />
          );
      }
    },
    type: 'error',
  },

  [MEMBER_PROMOTE_MODERATOR]: {
    content: () => (
      <Interpolate
        i18nKey="messages.user-promoted-moderator"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [MEMBER_DEMOTE_MODERATOR]: {
    content: () => (
      <Interpolate
        i18nKey="messages.user-demoted-moderator"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },

  [MEMBER_BLOCK]: {
    content: () => (
      <Interpolate
        i18nKey="messages.user-blocked"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [MEMBER_UNBLOCK]: {
    content: () => (
      <Interpolate
        i18nKey="messages.user-unblocked"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },

  [CATEGORY_DELETE]: {
    content: () => (
      <Interpolate
        i18nKey="messages.category-deleted"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [CATEGORY_UPDATE]: {
    content: () => (
      <Interpolate
        i18nKey="messages.category-updated"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [CATEGORY_SUBSCRIBED]: {
    content: () => (
      <Interpolate
        i18nKey="messages.category-subscribed"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [CATEGORY_UNSUBSCRIBED]: {
    content: () => (
      <Interpolate
        i18nKey="messages.category-unsubscribed"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },

  [REQUIRE_PROFILE_FIELDS]: {
    content: data => {
      const { name, image, cover } = data;
      if (name) {
        return (
          <Interpolate
            i18nKey="messages.profile-name-required"
            useDangerouslySetInnerHTML={true}
          />
        );
      }
      if (image) {
        return (
          <Interpolate
            i18nKey="messages.profile-image-uploading"
            useDangerouslySetInnerHTML={true}
          />
        );
      }
      if (cover) {
        return (
          <Interpolate
            i18nKey="messages.profile-cover-uploading"
            useDangerouslySetInnerHTML={true}
          />
        );
      }
      return (
        <Interpolate
          i18nKey="messages.profile-unknown-error"
          useDangerouslySetInnerHTML={true}
        />
      );
    },
    type: 'error',
  },
  [PROFILE_UPDATE]: {
    content: () => (
      <Interpolate
        i18nKey="messages.profile-updated"
        useDangerouslySetInnerHTML={true}
      />
    ),
  },
  [PROFILE_UPDATE_FAILED]: {
    content: () => (
      <Interpolate
        i18nKey="messages.profile-update-failed"
        useDangerouslySetInnerHTML={true}
      />
    ),
    type: 'error',
  },

  [DEMO_MODE_SITE]: {
    content: () => (
      <Interpolate
        i18nKey="messages.demo-mode-site"
        useDangerouslySetInnerHTML={true}
      />
    ),
    type: 'info',
  },
  [DEMO_MODE_EDITOR]: {
    content: () => (
      <Interpolate
        i18nKey="messages.demo-mode-editor"
        useDangerouslySetInnerHTML={true}
      />
    ),
    type: 'info',
  },
  [DEMO_MODE_PREVIEW]: {
    content: (data, t) => (
      <Interpolate
        i18nKey="messages.demo-mode-preview"
        activate={
          <span
            style={{ cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => Wix.Preview.openSettingsDialog()}
          >
            {t('messages.demo-mode-preview-activate')}
          </span>
        }
        useDangerouslySetInnerHTML={true}
      />
    ),
    type: 'info',
  },
};



// WEBPACK FOOTER //
// ./app/components/message/messages.js